// The 'value' property is required for compatibility with ChipInput.
// ChipInput expects each option to have a 'value' string property, which is used for selection and storage.
// Here, 'value' is set to the same value as 'id' for consistency and ease of lookup.
import { TrendingUp, FileText, Lightbulb, Briefcase, Heart, BookOpen } from 'lucide-react';

export const learningGoals = [
  { id: 'improve_grades', value: 'improve_grades', label: 'Improve my grades', icon: TrendingUp, color: '#4285F4' },
  { id: 'learn_new_skills', value: 'learn_new_skills', label: 'Learn new skills', icon: Lightbulb, color: '#FBC02D' },
  { id: 'homework_help', value: 'homework_help', label: 'Get help with homework', icon: BookOpen, color: '#34A853' },
  { id: 'filling_learning_gaps', value: 'filling_learning_gaps', label: 'Filling Learning Gaps', icon: Heart, color: '#EA4335' },
  { id: 'exam_prep', value: 'exam_prep', label: 'Prepare for exams', icon: FileText, color: '#1CC8B0' },
  { id: 'career_advancement', value: 'career_advancement', label: 'Advance my career', icon: Briefcase, color: '#AA46BB' },
]; 